import * as React from "react";
import {PageLayout  , InfoSection , Header , Util  } from "baziigram";
import DeveloperNavbar from "../components/DeveloperNavbar"
import { navigate } from "gatsby";
import { useEffect , useState } from "react";
import {dictionary} from "../constants"

const IndexPage = () => {

 const [language , setLanguage] = useState("en")
 const [direction , setDirection] = useState("ltr")

useEffect(() => {
let l = Util.getLanguage()
setLanguage(l)
setDirection(l=="fa"?"rtl":"ltr")

var div = document.getElementById("gatsby-focus-wrapper").firstElementChild;
div.addEventListener("scroll" , reveal)
        reveal();
         return () => {
                   var div = document.getElementById("gatsby-focus-wrapper").firstElementChild;
                   div.removeEventListener("scroll" , reveal)
                };
    }, []);

    const reveal = () => {
        var reveals = document.getElementsByTagName("section");
        for (var i = 0; i < reveals.length; i++) {
            var windowHeight = window.innerHeight;
            var elementTop = reveals[i].getBoundingClientRect().top;
            var elementVisible = 50;
            if (elementTop < windowHeight - elementVisible && reveals[i].classList.contains('active')==false) {
                reveals[i].classList.add('active');
            }
        }
    };




    return (  <PageLayout>
      <DeveloperNavbar />
      <Header headerLeftImage={"./images/Developer/headerLeft-2.png"}
      headerRightImage={"./images/main-page/phoenix-developer.png"} leftImageClass="left-image">
      <div class={`${direction} header-title`}>
      {dictionary.beSeenWithUs[language]}
      </div>
      </Header>
               <div
                id="content" >
                <InfoSection
                    content={{
                        h: dictionary.mainPageTitles[0][language],
                        p: dictionary.mainPageTexts[0][language],
                        img: "/images/Developer/publishGame.jpg",
                    }}
                    reverse={false}
                />
                <InfoSection
                    content={{
                        h: dictionary.mainPageTitles[1][language],
                        p: dictionary.mainPageTexts[1][language],
                        img: "/images/Developer/earnMoney.jpg",
                    }}
                    reverse={true}
                />
                <InfoSection
                    content={{
                        h: dictionary.mainPageTitles[2][language],
                        p: dictionary.mainPageTexts[2][language],
                        img: "/images/Developer/advertising.jpg",
                    }}
                    reverse={false}
                />
            </div>

        </PageLayout>
    );
}

export default IndexPage;
